/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.BookmarksChirpService
 */

export const addBookmarkRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.BookmarksChirpService',
  rpcName: 'addBookmark',
  auth: 'app',
  fingerprint: 'gluZ8oZseRvLcvNpM2pNJbCLJhY-dMN3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removeBookmarkRpc = {
  serviceName: 'com.hubspot.learning.center.user.progress.rpc.BookmarksChirpService',
  rpcName: 'removeBookmark',
  auth: 'app',
  fingerprint: 'oWeK-VfTpfXLcvNpM2pNJbCLJhY-dMN3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};